import { render, staticRenderFns } from "./SlidePop.vue?vue&type=template&id=1b3995e8&scoped=true"
import script from "./SlidePop.vue?vue&type=script&lang=ts"
export * from "./SlidePop.vue?vue&type=script&lang=ts"
import style0 from "./SlidePop.vue?vue&type=style&index=0&id=1b3995e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3995e8",
  null
  
)

export default component.exports